// Modal acessível: fecha no Esc, devolve o foco, e o fundo não rola atrás.
// Sem isto, quem abre o drilldown numa tabela longa perde a posição da lista.

import { useEffect, useRef, type ReactNode } from "react";

export function Modal({
  titulo,
  onFechar,
  children,
  largura = "max-w-lg",
}: {
  titulo: string;
  onFechar: () => void;
  children: ReactNode;
  largura?: string;
}) {
  const focoAnterior = useRef<Element | null>(null);

  useEffect(() => {
    focoAnterior.current = document.activeElement;
    const overflowAnterior = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key === "Escape") onFechar();
    };
    document.addEventListener("keydown", aoTeclar);

    return () => {
      document.removeEventListener("keydown", aoTeclar);
      document.body.style.overflow = overflowAnterior;
      (focoAnterior.current as HTMLElement | null)?.focus?.();
    };
  }, [onFechar]);

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-azul/35 p-4"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onFechar();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={titulo}
        className={`thin-scroll max-h-[88vh] w-full ${largura} overflow-y-auto rounded-[14px] border border-linha bg-superficie p-[26px] shadow-2xl`}
      >
        <div className="mb-3 flex items-start justify-between gap-4">
          <h2 className="font-display text-[17px] font-bold tracking-tight">{titulo}</h2>
          <button
            type="button"
            onClick={onFechar}
            aria-label="Fechar"
            className="grid size-7 shrink-0 place-items-center rounded-lg border border-linha text-tinta-fraca hover:bg-superficie-2"
          >
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
